module.exports = __webpack_public_path__ + "img/ic_calendar_blue.9da66e80.svg";